<template>
  <div class="device">
    <div class="icon">
      <v-icon class="main-icon">
        {{ icon }}
      </v-icon>
      <div class="device-title">
        <v-avatar
          class="badge"
          :size="27">
          <v-icon small>
            {{ icon }}
          </v-icon>
        </v-avatar>{{ title }}
      </div>
      <div>
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
      default: null
    },
    title: {
      type: String,
      required: true,
      default: null
    },
    description: {
      type: String,
      required: true,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
    @import "~common-assets/scss/we";

    .device {
        padding: 5px;
        text-align: center;
        height: 160px;
        width: 95%;
        border: 1px solid black;
        margin: 3px;
        position: relative;
        cursor: pointer;
        font-size: 12px;
        .icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .main-icon {
              color: black;
            }
            .device-title {
                margin-top: 10px;
                font-size: 15px;
                font-weight: bold;
                @extend .text-no-wrap;
                .badge {
                  border: 1px solid gray;
                  margin: 0 5px;
                }
            }
            .v-icon {
                font-size: 65px;
            }
        }
    }
</style>
